export default __webpack_public_path__ + "static/media/2.27a86c9e.jpg";